import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useOnboardingProcess from '@hooks/useOnboardingProcess';
import {
  selectComment,
  setCanvasMode,
  setDrawToolsShape
} from '@redux/actions/mediaViewerAction';

export default function useMediaViewerReviewAssetTour({
  isAssetReady,
  isAudio,
  isPreparing,
  isUnsupported,
  assetWorkspaceId
}: {
  isAssetReady: boolean;
  isAudio: boolean;
  isPreparing: boolean;
  isUnsupported: boolean;
  assetWorkspaceId?: string;
}) {
  const { onStartTour } = useOnboardingProcess();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const startTour = searchParams.get('startTour');

  const onStartTourReviewAsset = useCallback(() => {
    onStartTour({
      type: 'review-asset',
      onClickNext: (currentStep, isExitTour) => {
        if (isExitTour) return;
        if (currentStep === 0) {
          dispatch(selectComment('new'));
          dispatch(setCanvasMode('edit'));
          dispatch(setDrawToolsShape('pin'));
          return;
        }
        if (currentStep === 1) {
          dispatch(setCanvasMode('view'));
          dispatch(selectComment(null));
        }
      },
      onClickPrev: (currentStep, isExitTour) => {
        if (isExitTour) return;
        if (currentStep === 1) {
          dispatch(setCanvasMode('view'));
          return;
        }
        if (currentStep === 2) {
          dispatch(selectComment('new'));
          dispatch(setCanvasMode('edit'));
          dispatch(setDrawToolsShape('pin'));
        }
      }
    });
  }, [onStartTour, dispatch]);

  useEffect(() => {
    if (startTour !== 'review-asset') return;
    if (!assetWorkspaceId) return;
    if (isAudio || isUnsupported) return;
    if (isPreparing) return;
    if (!isAssetReady) return;
    onStartTourReviewAsset();
  }, [
    startTour,
    assetWorkspaceId,
    isAssetReady,
    isAudio,
    isPreparing,
    isUnsupported,
    onStartTourReviewAsset
  ]);

  return null;
}
